import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../utils/API';
import './awards.css';

export default function NominationAccept() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('loading');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    API.acceptNomination(token)
      .then(res => {
        setData(res.data);
        setState(res.data.already ? 'already' : 'success');
      })
      .catch(err => {
        setError(err.response?.data?.msg || 'Something went wrong. Please try again.');
        setState('error');
      });
  }, [token]);

  if (state === 'loading') {
    return (
      <div className="awards-page">
        <div className="awards-loading">Processing your nomination…</div>
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="awards-page">
        <div className="nom-response-card nom-response-error">
          <i className="bi bi-exclamation-circle nom-response-icon" />
          <h2 className="nom-response-title">Something went wrong</h2>
          <p className="nom-response-body">{error}</p>
        </div>
      </div>
    );
  }

  const firstName = data?.nominee_name?.split(' ')[0] || 'there';
  const categoryLabel = data?.category_label || 'this award';

  return (
    <div className="awards-page">
      <div className="nom-response-card nom-response-accept">
        <i className="bi bi-trophy-fill nom-response-icon" />
        <h2 className="nom-response-title">
          {state === 'already' ? `You're already on the ballot!` : `Congratulations, ${firstName}!`}
        </h2>
        <p className="nom-response-body">
          {state === 'already'
            ? `Your nomination for ${categoryLabel} has already been accepted — you're on the ballot. Good luck!`
            : `Your nomination for ${categoryLabel} has been accepted. You're officially on the ballot, and your peers will cast their votes soon. Well deserved!`}
        </p>
        <div className="nom-response-divider" />
        <p className="nom-response-cta-text">
          Pay it forward — is there someone in your network who deserves recognition from their peers?
        </p>
        <button className="nom-response-btn" onClick={() => navigate('/awards')}>
          <i className="bi bi-pencil-square me-2" />Nominate Someone
        </button>
      </div>
    </div>
  );
}
